import { Card } from '@mui/material';
import { Box, styled } from '@mui/system';
import {
  AvatarDataType,
  ContentType,
  EMPTY_PAGE_TEXT,
  MediaStatus,
  MediaStatusType,
} from '../../utils';
import { PublicAvatarLibrary } from './PublicAvatarLibrary';
import { PrivateAvatarLibrary } from './PrivateAvatarLibrary';
import { SectionTitle } from '@t2c/shared-fe';
import EmptyPage from '../../Common/EmptyPage';
import { AIMediaStatus } from 'apps/t2c-fe/@types';
import { is } from 'date-fns/locale';

interface StyledCardProps {
  status?: MediaStatusType | AIMediaStatus;
  isActive?: boolean;
}

export const StyledCard = styled(Card)<StyledCardProps>(({ status, theme, isActive=false }) => ({
  height: 194,
  cursor: 'pointer',
  overflow: 'visible',
  zIndex: 'auto',
  borderColor: isActive ? theme.palette.background.activeBorder : theme.palette.background.secondary,
  backgroundColor: 'transparent',
  '&:hover': {
    // boxShadow: status === MediaStatus.Success ? '0px 4px 16px -8px #AC9DD7' : '',
    boxShadow: theme.shadows[6],
    border: `1px solid ${
      status === MediaStatus.Success
        ? theme.palette.background.activeBorder
        : status === MediaStatus.Error
        ? theme.palette.background.errorCard
        : status === MediaStatus.NotStarted
        ? theme.palette.background.draftCard
        : theme.palette.background.border
    }`,
    '& .avatar-box': {
      background:
        status === MediaStatus.Success
          ? theme.palette.background.activeCard
          : status === MediaStatus.Error
          ? theme.palette.background.errorCard
          : status === MediaStatus.NotStarted
          ? theme.palette.background.draftCard
          : theme.palette.background.secondary,
    },
    '& .avatar-footer': {
      background:
        status === MediaStatus.Success
          ? theme.palette.background.activeBorder
          : status === MediaStatus.Error
          ? theme.palette.background.errorCard
          : status === MediaStatus.NotStarted
          ? theme.palette.background.draftCard
          : theme.palette.background.activeCard,
    },
    '& .avatar-footer .avatar-name': {
      color: status === MediaStatus.Success ? theme.palette.text.activeBorder : '',
    },
    '& .avatar-footer .avatar-time': {
      color:
        status === MediaStatus.Success
          ? theme.palette.text.activeBorder
          : theme.palette.text.dateAndTime,
    },
  },
}));

export const AvatarBox = styled(Box)<StyledCardProps>(({ height, theme, status }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: height ? `${height}` : '100%',
  background:
    status === MediaStatus.Error
      ? theme.palette.background.errorCard
      : status === MediaStatus.NotStarted
      ? theme.palette.background.draftCard
      : theme.palette.background.secondary,
  padding: '10px',
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
  cursor: 'pointer',
  // boxShadow: '4px 0px 8px 0px rgba(0, 0, 0, 0.1)',
}));

interface FooterBoxProps {
  defaultbackground?: 'true' | 'false';
  children: React.ReactNode;
  status?: MediaStatusType | AIMediaStatus;
}

export const FooterBox = styled(Box)<FooterBoxProps>(({ theme, defaultbackground, status }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '15%',
  color: theme.palette.text.primary,
  paddingLeft: '8px',
  paddingRight: '8px',
  background:
    defaultbackground === 'true'
      ? theme.palette.background.default
      : status === MediaStatus.Error
      ? theme.palette.background.errorCard
      : status === MediaStatus.NotStarted
      ? theme.palette.background.draftCard
      : theme.palette.background.secondary,
  borderBottomLeftRadius: '8px',
  borderBottomRightRadius: '8px',
}));

interface AvatarSectionProps {
  publicAvatars: AvatarDataType[];
  privateAvatars: AvatarDataType[];
}

// function AvatarSection({ publicAvatars, privateAvatars }: AvatarSectionProps) {
//   return (
//     <>
//       <Box>
//         <SectionTitle variant="h4">Your Created Avatar</SectionTitle>
//         {(privateAvatars ?? []).length === 0 ? (
//           <EmptyPage minimumHeight="10vh" text={EMPTY_PAGE_TEXT.avatar} type={ContentType.Avatar} />
//         ) : (
//           <PrivateAvatarLibrary privateAvatars={privateAvatars} />
//         )}
//       </Box>
//       <Box sx={{ marginBottom: 2 }}>
//         <PublicAvatarLibrary publicAvatars={publicAvatars} />
//       </Box>
//     </>
//   );
// }

// export default AvatarSection;
